import type { EmailCampaignMessageStatus } from '@/data/models/domain/campaign/EmailCampaignMessage'
import type { RequireAtLeastOne } from '@/types'
import type { TmWrappers } from '@/wrappers'

export const contactListTempDetailsModalId: TmWrappers = 'contactListTempDetails'

export interface UpdatedContactListTempResponse {
  groupId: number
  membersCount: number
}

export interface CreateListTempRequestBody {
  all: boolean | void
  allowedShared: boolean
  ids?: string[]
}

export interface ExpandListTempRequestBody {
  id: string
  ids: string[]
}

interface ICreateListTempForBulkEmailCampaignFilter {
  id?: RequireAtLeastOne<{
    in: number[]
    notIn: number[]
  }>
  status?: RequireAtLeastOne<{
    in: EmailCampaignMessageStatus[]
  }>
}

export interface ICreateListTempForBulkEmailCampaignParamsFilters {
  searchQuery?: string
  filters?: ICreateListTempForBulkEmailCampaignFilter[]
}
